import React, { useState } from "react";
import { createContext } from "react";
import { signInWithEmailAndPassword,
         getAuth,
         signOut,
         sendPasswordResetEmail,
         createUserWithEmailAndPassword,         
         sendEmailVerification,
         onAuthStateChanged,
         updateEmail
         } from "firebase/auth";
import { getFirestore, doc, setDoc, getDoc, collection, getDocs, deleteField } from "firebase/firestore";
import { deleteDoc } from "firebase/firestore";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import app from "../services";



export const FirebaseFuntions = createContext()

const FirebaseContext = ({ children }) => {

    const auth = getAuth(app)
    const db = getFirestore(app)
    const storage = getStorage(app)
    

    const date = new Date()
    const [loginStatus, setLoginStatus] = useState(false)
    const [loginFlag, setLoginFlag] = useState(false)
    const [userProject, setUserProject] = useState("")
    const [idDoc, setIdDoc] = useState()
    const [authID, setAuthID]   = useState("")
    
    const readAllProjects = async () => {
        const docRef = collection(db, "projects")
        const docSnap = await getDocs(docRef)
        const docId = docSnap.docs.map((doc) => doc.id)
        return docId
    }

    const userLogin = async (data) => {
        const { mail, password } = data;
        try {
            const company="gedeon"
            const data = await signInWithEmailAndPassword(auth, mail, password);                         
            const docRef = collection(db, company)
            //console.log(company)         
            const docSnap = await getDocs(docRef)
            const docData = docSnap.docs.map((doc) => {
                if(doc.data().authID === data.user.uid){                    
                    return doc.id;
                } else {
                    return null;
                } 
            });
            const docFilter = docData.filter((doc) => doc !== null)
            if (docFilter.length !== 0) {
                //console.log(docFilter);
                setIdDoc(docFilter)
                setUserProject(company)
                setLoginFlag(true) 
            }                                 
            return ("Sesión iniciada");                 

        } catch (error) {
            setLoginFlag(false);

            if (error.code === 'auth/wrong-password' ) {
                return ("Contraseña incorrecta");
            } else if (error.code === 'auth/user-not-found') {
                return ("Usuario no encontrado");
            } else if (error.code === 'auth/invalid-email') {
                return ("Email invalido");
            } else if (error.code === 'auth/too-many-requests') {
                return ("Demasiados intentos fallidos, por favor intente mas tarde");
            }
            else {
                console.log(error);
                return ("Por favor comuniquese con el administrador");
            }            
        }
    };

    const userLogout = async ( ) => {        

        try {
            await signOut(auth);
            setLoginFlag(false);
            console.log("Sesión cerrada");            
            return ("Sesión cerrada");
        } catch (error) {
            console.log(error);
            return ("Por favor comuniquese con el administrador");
        }
    };

    const userForgotPassword = async (data) => {
        const { mail } = data;
        try {
            await sendPasswordResetEmail(auth, mail);
            return ("Se ha enviado un email a su cuenta de correo para restablecer su contraseña");
        } catch (error) {
            if (error.code === 'auth/user-not-found') {
                return ("Usuario no encontrado");
            } else if (error.code === 'auth/invalid-email') {
                return ("Email invalido");
            }
            else {
                console.log(error);
                return ("Por favor comuniquese con el administrador");
            }
        }
    };

    const createUser = async (data) => {
        const { name, lastname, phone, mail, password, userId, projectId, terms, job } = data;
        try {
            const user = await createUserWithEmailAndPassword(auth, mail, password) 
            const userRef = doc(db, projectId , userId ? userId : user.user.uid);
            await setDoc(userRef, {
                authID: user.user.uid,
                projectId: projectId,
                userId: userId,
                name: name, 
                lastname: lastname,               
                email: mail,
                job: job,
                template: "promo",
                gender: "male",
                footer: null,
                phone: phone,                                                                
                role: "user",
                dateOfCreation: date,
                terms: terms,
                photo: null
            });
            await sendEmailVerification(user.user); //Envia email de verificacion
            
            return ("Usuario creado correctamente");            
        } catch (error) {
            if (error.code === 'auth/email-already-in-use') {
                return ("El email ya esta en uso");
            } else if (error.code === 'auth/invalid-email') {
                return ("Email invalido");
            } else if (error.code === 'auth/weak-password') {
                return ("La contraseña debe tener al menos 6 caracteres");
            }
            else {
                console.log(error);
                return ("Por favor comuniquese con el administrador");
            }
        }
    };

    const searchUser = async (userId, projectId) => {
        const userRef = doc(db, projectId, userId);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
            return userSnap.data();
        } else {
            return null;
        }
    };

    const authStatus = () => {
        onAuthStateChanged(auth, (user) => {
            if (user) {        
                setLoginFlag(true);
                setAuthID(user.uid);                
                //console.log("Sesión iniciada");                                    
            } else {                
                setLoginFlag(false);                              
            }
        });       
    };

    const userExists = async (userId, projectId) => {
        const userRef = doc(db, projectId, userId);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
            return true;
        } else {
            return false;
        }
    };

    const uploadPhoto = async (file, nameFile, docuId, projectId) => {
        const storageRef = ref(storage, `${projectId}/${nameFile}`);
        try {
            await uploadBytes(storageRef, file).then(( ) => {
                console.log("Uploaded file!");        
              });      
              const url = await getDownloadURL(storageRef);
              await writePhoto(docuId, projectId, url);
              return "La foto se cargo con éxito";
        } catch (error) {
            console.log(error);
            return "Error al subir la foto";
        }
    };
        
    const writePhoto = async (docuId, projectId, url) => {
        const quoteRef = doc(db, `${projectId}/`, docuId);
        const modelos = { photo: url };
        try {          
          await setDoc(quoteRef, modelos, { merge: true });          
        } catch (error) {
          console.log(error);
        }
      };

    //Carga de banner

    const uploadBanner = async (file, nameFile, docuId, projectId) => {
        const storageRef = ref(storage, `${projectId}/${nameFile}`);
        try {
            await uploadBytes(storageRef, file).then(( ) => {
                console.log("Uploaded file!");        
              });      
              const url = await getDownloadURL(storageRef);
              await writeBanner(docuId, projectId, url);
              return "El banner se cargo con éxito";
        } catch (error) {
            console.log(error);
            return "Error al subir el banner";
        }
    };

    //Carga la ruta del banner en el perfil del usuario
        
    const writeBanner = async (docuId, projectId, url) => {
        const quoteRef = doc(db, `${projectId}/`, docuId);
        const modelos = { banner: url };
        try {          
          await setDoc(quoteRef, modelos, { merge: true });          
        } catch (error) {
          console.log(error);
        }
    };

    const updateUser = async (data) => {
        const { name, lastname, phone, linkedin, puesto, userId, projectId, facebook, twitter, instagram, web, email, job, gender, template, footer, typeoffooter, footer_text } = data 
        if (email){
            try{
                //console.log("Actualizando email")
                updateEmail(auth.currentUser, email)                
            } catch (error) {
                console.log(error)           
            }
        }     
        const userRef = doc(db, projectId, userId);        
        const modelo = {
            ...(name ? {name} : {}), 
            ...(lastname ? {lastname}: {}),
            ...(phone ? {phone} : {}),
            ...(linkedin ? {linkedin} : {}),
            ...(puesto ? {puesto} : {}),
            ...(job ? {job} : {}),
            ...(gender ? {gender} : {}),
            ...(footer ? {footer} : null),
            ...(template ? {template} : {}),
            ...(facebook ? {facebook} : {}),
            ...(twitter ? {twitter} : {}),
            ...(instagram ? {instagram} : {}),
            ...(web ? {web} : {}),    
            ...(email ? {email} : {}),
            ...(typeoffooter ? {typeoffooter} : null),   
            ...(footer_text ? {footer_text} : null)     
        }
        if (userRef){
            try{                
                await setDoc(userRef,modelo, { merge : true});
            } catch (error) {
                console.log(error)
            }            
            return "Usuario actualizado"
        } else{
            return "El usuario no existe"
        }
        
    };

    const deleteSocial = async (data) => {
        const { userId, projectId, social } = data;
        const userRef = doc(db, projectId, userId);
        const modelo = {
            [social]: deleteField()
        }
        if (userRef){
            try{
                await setDoc(userRef,modelo, { merge : true});
            } catch (error) {
                console.log(error)
            }
            return "Usuario actualizado"
        } else{
            return "El usuario no existe"
        }
    };   
    
    const projectPhoto = async (projectId) => {
        //console.log(projectId)
        const docRef = doc(db, 'projects', projectId)
        const docSnap = await getDoc(docRef)
        const docId = docSnap.data()
        
        try {
            return docId
        } catch (error) {
            console.log(error)
            return "Error al cargar los proyectos"
        }        
    }

    const createUserAdmin = async (data) => {
        const { name, lastname, phone, email, slug, projectId="gedeon", job, linkedin, facebook, twitter, instagram, web, video, role, template } = data
        try {
            if (slug !== null || name !== null || lastname !== null || email !== null){
                const userRef = doc(db, projectId , slug )
                await setDoc(userRef, {
                    
                    projectId: projectId,
                    userId: slug,
                    name: name, 
                    lastname: lastname,               
                    email: email,
                    job: job,
                    photo: null,
                    template: template ? template : "promo",
                    gender: "male",
                    footer: null,
                    phone: phone,                                                                
                    role: role ? role : "user",
                    dateOfCreation: date,                                
                    linkedin: linkedin ? linkedin : null,
                    facebook: facebook ? facebook : null,
                    twitter: twitter ? twitter : null,
                    instagram: instagram ? instagram : null,
                    web: web ? web : null,
                    video : video ? video : null

                }) 
            }  else {
                return ("No se pudo crear el usuario")   
            }            
            return ("Usuario creado correctamente")           

        } catch (error) {
            console.log(error)
            return ("Por favor comuniquese con el administrador")
        }
    } 
    
    const updateUserAdmin = async (data) => {
        const { name, lastname, phone, email, slug, projectId="gedeon", job, linkedin, facebook, twitter, instagram, web, video, role, template } = data
             
        const userRef = doc(db, projectId, slug)
        const modelo = {
            ...(name ? {name} : {}), 
            ...(lastname ? {lastname}: {}),
            ...(phone ? {phone} : {}),
            ...(linkedin ? {linkedin} : {}),            
            ...(job ? {job} : {}),            
            ...(template ? {template} : {}),
            ...(facebook ? {facebook} : {}),
            ...(twitter ? {twitter} : {}),
            ...(instagram ? {instagram} : {}),
            ...(web ? {web} : {}),    
            ...(email ? {email} : {}),   
            ...(video ? {video} : {}),
            ...(role ? {role} : {})           
        }
        if (userRef){
            try{                
                await setDoc(userRef,modelo, { merge : true});
            } catch (error) {
                console.log(error)
            }            
            return "Usuario actualizado"
        } else{
            return "El usuario no existe"
        }
        
    }

    const readUserAdmin = async () => {
        const docRef = collection(db, "gedeon")        
        const docSnap = await getDocs(docRef)                
        const docData = docSnap.docs.map((doc) => doc.data())             
        return docData
    }

    const deleteUserAdmin = async (slug) => {        
        console.log(slug)
        try {
            const userRef = doc(db, "gedeon", slug)
            await deleteDoc(userRef)
            return ("Usuario eliminado correctamente")
        } catch (error) {
            console.log(error)
            return ("Por favor comuniquese con el administrador")
        }
    }

    return (
        <FirebaseFuntions.Provider value={{
            loginStatus,
            loginFlag, 
            idDoc,
            authID,
            userProject,
            updateUserAdmin,
            deleteUserAdmin, 
            readUserAdmin,
            createUserAdmin,
            projectPhoto,       
            userExists,
            deleteSocial,
            uploadBanner,
            writeBanner,
            setAuthID,
            updateUser,
            uploadPhoto,
            authStatus,
            setIdDoc,
            searchUser,
            setLoginFlag,
            createUser,
            userForgotPassword,
            userLogout,
            setLoginStatus,
            userLogin,
            readAllProjects
        }}>
            {children}
        </FirebaseFuntions.Provider>
    );
}

export default FirebaseContext;